import API from '../../api';
import { UserContainer } from '../../providers';
// eslint-disable-next-line import/no-cycle
import { useInitializeApp } from './auth';

const useGetUser = () => {
  const { setUser } = UserContainer.useContainer();
  const getUser = async () => {
    const response = await API.user.get();
    setUser(response.data[0]);
    return response.data[0];
  };
  return getUser;
};

const useGetUserById = () => {
  const { setUser } = UserContainer.useContainer();
  const getUserById = async id => {
    const response = await API.user.get(id);
    setUser(response.data[0]);
    return response.data[0];
  };
  return getUserById;
};

const useCreateUser = () => {
  // eslint-disable-next-line no-unused-vars
  const initializeApp = useInitializeApp();
  const createUser = async data => {
    const createdUser = await API.user.create(data);
    return createdUser;
  };
  return createUser;
};

const usePatchUser = () => {
  const { state: userState, setUser } = UserContainer.useContainer();
  const patchUser = async payload => {
    const response = await API.user.update(userState.user.id, payload);
    setUser({
      ...response,
      currency: userState.user.currency,
    });
  };
  return patchUser;
};

const useGetPermissions = () => {
  const {
    setPermissions,
    setAllPermissions,
    state: userState,
  } = UserContainer.useContainer();
  const getPermissions = async (userId, businessId = '') => {
    const response = await API.permission.find({ userId });
    const currentBusinessPermission = response.filter(
      permission => permission.businessId === businessId
    );
    if (currentBusinessPermission.length > 0) {
      setPermissions(currentBusinessPermission[0]);
    } else {
      setPermissions(response[0]);
    }
    setAllPermissions(response);
  };
  return getPermissions;
};

const useSetPermissions = () => {
  const { state: userState, setPermissions } = UserContainer.useContainer();

  const setCurrentBusinessPermission = currentBusinessId => {
    if (currentBusinessId) {
      const currentBusinessPermission = userState?.allPermissions?.filter(
        business => business.businessId === currentBusinessId.toString()
      );

      if (currentBusinessPermission?.length > 0) {
        setPermissions(currentBusinessPermission[0]);
      }
    }
  };

  return setCurrentBusinessPermission;
};

const useDeleteUser = () => {
  const deleteUser = async payload => {
    await API.user.delete(payload);
  };
  return deleteUser;
};

export {
  useGetUser,
  useCreateUser,
  usePatchUser,
  useDeleteUser,
  useGetPermissions,
  useGetUserById,
  useSetPermissions,
};
